var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cvview" },
    [
      _vm.selected !== undefined && _vm.selected.template === true
        ? _c(
            "b-navbar",
            { staticClass: "my-lg-2 mt-0", attrs: { variant: "primary" } },
            [
              _c(
                "b-navbar-nav",
                {
                  staticClass: "pr-3 align-items-center",
                  attrs: { justified: true },
                },
                [
                  _vm._l(_vm.sections, function (item, index) {
                    return _c(
                      "b-nav-item",
                      {
                        key: index,
                        staticClass: "text-uppercase",
                        attrs: {
                          to: _vm.url + "#" + item.path,
                          active: _vm.isActiveNav(item.path),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeSection({
                              path: item.path,
                              back: false,
                              navBar: true,
                            })
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.text))]
                    )
                  }),
                  _c(
                    "b-nav-item",
                    { staticClass: "nav-exit d-flex justify-content-end" },
                    [
                      _c("b-icon", {
                        staticClass: "pointer mx-3 d-none d-lg-block",
                        attrs: {
                          icon: "x-circle-fill",
                          scale: "2",
                          width: "20px",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.clearSelection("X in NavBar")
                          },
                        },
                      }),
                      _c(
                        "b-iconstack",
                        {
                          staticClass: "d-lg-none d-xl-none",
                          attrs: { scale: "2" },
                          on: {
                            click: function ($event) {
                              return _vm.clearSelection("X in NavBar")
                            },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              stacked: "",
                              icon: "circle-fill",
                              variant: "primary",
                            },
                          }),
                          _c("b-icon", {
                            attrs: {
                              stacked: "",
                              icon: "x-circle-fill",
                              scale: "0.9",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-nav-item", { staticClass: "d-lg-none d-xl-none" }, [
                    _c("div", { staticStyle: { width: "30px" } }),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "cv-settings d-flex justify-content-center",
              class: { hidden: _vm.showPreview },
              attrs: { cols: "12", lg: "5" },
            },
            [
              "2" === _vm.currentSection.path
                ? _c("CvStyling", {
                    attrs: {
                      section: _vm.currentSection,
                      langOptions: _vm.langOptions,
                      startFromLast: _vm.startFromLast,
                    },
                    on: {
                      changeSection: function ($event) {
                        return _vm.changeSection($event)
                      },
                      clearSelect: _vm.clearSelection,
                    },
                  })
                : _vm._e(),
              "3" === _vm.currentSection.path
                ? _c("CvAdjust", {
                    attrs: {
                      section: _vm.currentSection,
                      competencesLink: _vm.competencesLink,
                      startFromLast: _vm.startFromLast,
                    },
                    on: {
                      changeSection: function ($event) {
                        return _vm.changeSection($event)
                      },
                      clearSelect: _vm.clearSelection,
                    },
                  })
                : _vm._e(),
              "4" === _vm.currentSection.path
                ? _c("CvDownload", {
                    attrs: {
                      section: _vm.currentSection,
                      template: _vm.selected.template,
                      linkToDocuments: _vm.linkToDocuments,
                      documentsLinkName: _vm.documentsLinkName,
                      coverLetterId: _vm.selected.coverLetterId,
                    },
                    on: {
                      changeSection: function ($event) {
                        return _vm.changeSection($event)
                      },
                      clearSelect: _vm.clearSelection,
                      download: function ($event) {
                        return _vm.downloadCV($event, false)
                      },
                      saveInDocuments: function ($event) {
                        return _vm.saveInDocuments($event, false)
                      },
                      downloadCoverLetter: function ($event) {
                        return _vm.downloadCoverLetter()
                      },
                      saveCoverLetterInDocuments: function ($event) {
                        return _vm.saveCoverLetterInDocuments()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-block",
              class: { show: _vm.showPreview },
              attrs: { cols: "12", lg: "7" },
            },
            [
              _c("div", { staticClass: "cv-preview" }),
              _c(
                "PdfSlider",
                {
                  attrs: { url: _vm.previewUrl, height: "1156", width: "800" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "cv-preview-toolbar" },
                    [
                      [
                        _c(
                          "b-dropdown",
                          {
                            scopedSlots: _vm._u([
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "cloud-download",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          },
                          [
                            _c("h5", { staticClass: "ml-3" }, [
                              _vm._v(_vm._s(_vm.t.general_Download)),
                            ]),
                            _c("b-dropdown-text", {
                              staticClass: "dropdown-header px-3",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.t.CV_Tool_Download_CV_Download
                                ),
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mb-4" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center cv-download mx-3 py-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadCV(false, true)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "BaseIcon",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 1024 1024",
                                        },
                                      },
                                      [_c("WordFile")],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-light ml-2" },
                                      [_vm._v("Word")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center cv-download mx-3 py-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadCV(true, true)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "BaseIcon",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 1024 1024",
                                        },
                                      },
                                      [_c("PDFFile")],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-light ml-2" },
                                      [_vm._v("PDF")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.selected.coverLetterId !== 0
                              ? [
                                  _c("b-dropdown-text", {
                                    staticClass: "dropdown-header px-3",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.t.CV_Tool_Download_CL_Download
                                      ),
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center mb-4",
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center cv-download mx-3 py-1",
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadCoverLetter()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "BaseIcon",
                                            {
                                              attrs: {
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 1024 1024",
                                              },
                                            },
                                            [_c("WordFile")],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-light ml-2",
                                            },
                                            [_vm._v("Word")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _c("b-dropdown-divider"),
                            _c("h5", { staticClass: "ml-3" }, [
                              _vm._v(_vm._s(_vm.t.general_Save)),
                            ]),
                            _c("b-dropdown-text", {
                              staticClass: "dropdown-header px-3",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.t.CV_Tool_Download_CV_Save
                                ),
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mb-4" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center cv-download mx-3 py-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveInDocuments(false, true)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "BaseIcon",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 1024 1024",
                                        },
                                      },
                                      [_c("WordFile")],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-light ml-2" },
                                      [_vm._v("Word")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center cv-download mx-3 py-1",
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveInDocuments(true, true)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "BaseIcon",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 1024 1024",
                                        },
                                      },
                                      [_c("PDFFile")],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "font-weight-light ml-2" },
                                      [_vm._v("PDF")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.savingToDocuments === true
                              ? _c(
                                  "b-dropdown-text",
                                  { staticClass: "mt-1" },
                                  [
                                    _vm.savingToDocuments === true
                                      ? [
                                          _c("b-spinner", {
                                            attrs: {
                                              small: "",
                                              variant: "primary",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ml-1 text-brand-light",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.t.CV_Tool_Download_Saving
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.savingToDocuments === false &&
                            _vm.savedToDocuments === true
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-header d-flex text-nowrap",
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "text-muted mr-2",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.t.CV_Tool_Download_Saved
                                        ),
                                      },
                                    }),
                                    _vm.linkToDocuments !== undefined
                                      ? _c(
                                          "b-link",
                                          {
                                            key: "documentsLink",
                                            attrs: {
                                              href: _vm.linkToDocuments,
                                            },
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "text-brand-light mb-1",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.documentsLinkName
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.selected.coverLetterId !== 0
                              ? [
                                  _c("b-dropdown-text", {
                                    staticClass: "dropdown-header px-3",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.t.CV_Tool_Download_CL_Save
                                      ),
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center mb-4",
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center cv-download mx-3 py-1",
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveCoverLetterInDocuments()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "BaseIcon",
                                            {
                                              attrs: {
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 1024 1024",
                                              },
                                            },
                                            [_c("WordFile")],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-light ml-2",
                                            },
                                            [_vm._v("Word")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.savingCoverLetterToDocuments === true
                                    ? _c(
                                        "b-dropdown-text",
                                        { staticClass: "mt-1" },
                                        [
                                          _vm.savingCoverLetterToDocuments ===
                                          true
                                            ? [
                                                _c("b-spinner", {
                                                  attrs: {
                                                    small: "",
                                                    variant: "primary",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ml-1 text-brand-light",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.t
                                                          .CV_Tool_Download_Saving
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.savingCoverLetterToDocuments === false &&
                                  _vm.savedCoverLetterToDocuments === true
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-header d-flex text-nowrap",
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "text-muted mr-2",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.t
                                                  .CV_Tool_Cover_Letter_Download_Saved
                                              ),
                                            },
                                          }),
                                          _vm.linkToDocuments !== undefined
                                            ? _c(
                                                "b-link",
                                                {
                                                  key: "documentsLink",
                                                  attrs: {
                                                    href: _vm.linkToDocuments,
                                                  },
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "text-brand-light mb-1",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.documentsLinkName
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "bottom-box d-lg-none d-flex justify-content-end",
              attrs: { cols: "12" },
            },
            [
              _c(
                "b-button",
                { staticClass: "m-2", on: { click: _vm.togglePreview } },
                [
                  _c("b-icon", {
                    staticClass: "mr-1",
                    attrs: {
                      icon: _vm.showPreview ? "gear" : "file-earmark-text",
                      "aria-hidden": "true",
                    },
                  }),
                  [_vm._v(_vm._s(_vm.previewBtnText))],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }